import { useTranslation } from "react-i18next";
import NavBar from "../components/NavBar";
import { Link } from "react-router-dom";
import { trackCTA } from "../utils/eventTracker";
import BackgroundImage from "../components/BackgroundImage";
import Footer from "../components/Footer";

export default function Ute() {
  const { t } = useTranslation();
  return (
    <div className="page-wrapper">      
      <BackgroundImage />
      <NavBar />
      <div className="transparency-wrapper">
      <div className="big-title">UTE</div>
      <img
        src="/projects/ute.webp"
        alt="UTE"
        className="project-image"
      />
        <div className="porfolio-project-text-wrapper">
          <p className="section-content-unbounded">
            {t("uteDescriptionShort")}
          </p>
          <p className="section-content-unbounded">
            {t("uteDescriptionLong")}
          </p>
        </div>            
        <div className="cta-button-secondary-wrapper-bottom">
          <Link 
            to="/quote"
            className="cta-button-secondary"
            onClick={() => trackCTA("utePage")}
          >
            {t("ctaBookCall")}
          </Link>
        </div>        
        <Footer /> 
      </div>        
    </div>
  );
}
